/**
 * 50音順（五十音順）のヘルパー関数
 */

// 50音順のカテゴリ
export const GOJUON_CATEGORIES = [
  { label: '*', value: '' },           // すべて
  { label: '英数', value: 'other' },   // 英数字・記号
  { label: 'あ', value: 'あ' },
  { label: 'か', value: 'か' },
  { label: 'さ', value: 'さ' },
  { label: 'た', value: 'た' },
  { label: 'な', value: 'な' },
  { label: 'は', value: 'は' },
  { label: 'ま', value: 'ま' },
  { label: 'や', value: 'や' },
  { label: 'ら', value: 'ら' },
  { label: 'わ', value: 'わ' },
] as const;

/**
 * author_readingの1文字目から50音カテゴリを判定
 * @param authorReading - 作者名のふりがな
 * @returns 50音カテゴリ ('あ', 'か', 'さ', ..., 'other')
 */
export function getGojuonCategory(authorReading: string): string {
  if (!authorReading) return 'other';

  const firstChar = authorReading.charAt(0);

  // カタカナをひらがなに変換（ァ〜ン: U+30A1〜U+30F6 → U+3041〜U+3096）
  const char =
    firstChar >= 'ァ' && firstChar <= 'ン'
      ? String.fromCharCode(firstChar.charCodeAt(0) - 0x60)
      : firstChar;

  // ひらがなチェック
  if (char >= 'あ' && char <= 'お') return 'あ';
  if (char >= 'か' && char <= 'こ') return 'か';
  if (char >= 'さ' && char <= 'そ') return 'さ';
  if (char >= 'た' && char <= 'と') return 'た';
  if (char >= 'な' && char <= 'の') return 'な';
  if (char >= 'は' && char <= 'ほ') return 'は';
  if (char >= 'ま' && char <= 'も') return 'ま';
  if (char >= 'や' && char <= 'よ') return 'や';
  if (char >= 'ら' && char <= 'ろ') return 'ら';
  if (char >= 'わ' && char <= 'ん') return 'わ';

  // 英数字・記号
  return 'other';
}

/**
 * APIパラメータ用の値を取得
 * @param category - 50音カテゴリ ('あ', 'か', ..., 'other', '')
 * @returns API用のauthor_readingパラメータ値
 */
export function getApiFilterValue(category: string): string | undefined {
  if (!category || category === '') {
    return undefined;  // すべて表示
  }

  if (category === 'other') {
    // 英数字・記号の場合は特殊処理が必要
    // APIが対応していない場合はクライアント側でフィルタ
    return undefined;
  }

  // 'あ', 'か', 'さ' などはそのままAPIに渡す
  return category;
}
